export enum VehicleHistoryOrderByColumn {
  WorkOrder = 'domain.enums.order_columns_vehicle_history.work_order',
  EntryDate = 'domain.enums.order_columns_vehicle_history.entry_date',
}
